















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getAiAppDetail } from '@/apps/open/services/ai'
import { ConfigInfo } from '@/apps/open/types/transform'
import { TRANSFORM_DOC_URL } from '@/apps/open/constants'
import AdminLayout from '@/apps/open/layout/AdminLayout.vue'
import InputFormDialogBody from '@/apps/open/components/DialogBodys/InputForm.vue'
import EmailAdminDialogBody from '@/apps/open/components/DialogBodys/EmailAdmin.vue'

@Component({
  components: {
    AdminLayout
  },
  data: () => ({
    TRANSFORM_DOC_URL
  })
})
export default class Info extends Vue {
  breadcrumbs: any = []

  tabs = [{
    name: '权限申请',
    key: 'permission',
    showAction: true
  },
  {
    name: '应用信息',
    key: 'info',
    showAction: true
  }]

  activeTab = this.tabs[0]

  appInfo: any = {}
  hideAppKey = true

  permissionList = [
    {
      api_name: '上下位词',
      api_desc: '给定一个短语，自动提取相关词',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/generic-word'
    },
    {
      api_name: '关键词提取',
      api_desc: '给定文本自动提取关键词',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/keyword-extraction'
    },
    {
      api_name: '近义词发散',
      api_desc: '给定一个词语，自动联想近义词',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/synonym'
    },
    {
      api_name: '主题句提取',
      api_desc: '自动提取文本能表达中心思想的句子',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/topic-extraction'
    },
    {
      api_name: '文本摘要',
      api_desc: '给定文本自动提取文本摘要',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/text-summary'
    },
    {
      api_name: '新词发现',
      api_desc: '给定文本数据，识别出文本中的词语，对比旧词典发现新词',
      status: 1,
      doc_link: '/docs/doc-ai-open/NLP/new-word-descovery'
    },
    {
      api_name: '素材推荐',
      api_desc: '输入一句文本，从海量素材中精准推荐优质素材',
      status: 1,
      doc_link: '/docs/doc-ai-open/intelligent-write/material-recommand'
    },
    {
      api_name: '文本生成',
      api_desc: '输入文本，自动续写后续内容',
      status: 1,
      doc_link: '/docs/doc-ai-open/intelligent-write/text-generate'
    },
    {
      api_name: '文本校对',
      api_desc: '准确识别文本中出现的错字错词，并给出正确的建议修改项',
      status: 1,
      doc_link: '/docs/doc-ai-open/intelligent-write/text-check'
    },
    {
      api_name: '唐诗自动生成',
      api_desc: 'AI写诗，支持藏头诗、绝句的自动生成',
      status: 1,
      doc_link: '/docs/doc-ai-open/intelligent-write/tang-poem-generate'
    },
    {
      api_name: '宋词自动生成',
      api_desc: 'AI写词，支持20余种词牌名的自动生成',
      status: 1,
      doc_link: '/docs/doc-ai-open/intelligent-write/song-poem-generate'
    }
  ]

  switchAppKey () {
    this.hideAppKey = !this.hideAppKey
  }

  jumpDoc (doc_link: string) {
    window.open(doc_link)
  }

  initBreadcrumbs (app_name: string) {
    this.breadcrumbs.push({
      name: app_name
    })
  }

  async mounted () {
    const app_name = this.$route.params.app_name
    this.initBreadcrumbs(app_name)
    try {
      const params = {
        apiname: app_name
      }
      const res = await getAiAppDetail(params)
      this.appInfo = res.data.data
    } catch (error) {
      this.$message.error(error.message)
    }
  }
}
